import React from 'react';
import { Star, Quote } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Wedding Organizer",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
      rating: 5,
      text: "Desi Fusion made our wedding absolutely amazing! The food was incredible and all our guests couldn't stop raving about the samosas and butter chicken. Highly recommend for any event!"
    },
    {
      id: 2,
      name: "Rupesh Jadhav",
      role: "Corporate Event Manager",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
      rating: 5,
      text: "We hired Desi Fusion for our company festival and it was a huge hit! Professional service, authentic flavors, and the presentation was top-notch. Will definitely book again."
    },
    {
      id: 3,
      name: "Priya Patel",
      role: "Birthday Party Host",
      image: "https://i.ibb.co/6RW4q8qc/IMG-20260328-WA0034.jpg",
      rating: 5,
      text: "The best Indian street food I've had outside of India! The team was friendly, the food truck looked amazing, and the chai was perfect. Made my birthday celebration extra special."
    }
  ];

  return (
    <section id="testimonials" className="relative py-24 bg-gradient-to-b from-white via-orange-50 to-white overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-20 left-0 w-96 h-96 bg-gradient-to-br from-orange-200/30 to-yellow-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-0 w-80 h-80 bg-gradient-to-tl from-emerald-200/20 to-green-200/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-orange-600 font-bold text-sm uppercase tracking-wider bg-gradient-to-r from-orange-100 to-yellow-100 px-4 py-2 rounded-full border border-orange-200">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-burgundy-800 via-red-700 to-orange-700 bg-clip-text text-transparent mt-6 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-gray-700 text-lg max-w-2xl mx-auto">
            Don't just take our word for it - hear from clients who've experienced the magic of Desi Fusion
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-orange-100 hover:border-orange-300"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-orange-200 group-hover:text-orange-300 transition-colors">
                <Quote size={40} fill="currentColor" />
              </div>

              {/* Rating */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} className="fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 leading-relaxed mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-4 pt-4 border-t-2 border-orange-100">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover border-2 border-orange-200"
                />
                <div>
                  <p className="font-bold text-burgundy-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Stats */}
        <div className="mt-16 grid grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent mb-2">50+</div>
            <div className="text-gray-600">Events Served</div>
          </div>
          <div className="text-center border-l border-r border-gray-200">
            <div className="text-4xl font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent mb-2">4.9★</div>
            <div className="text-gray-600">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-orange-500 to-yellow-500 bg-clip-text text-transparent mb-2">98%</div>
            <div className="text-gray-600">Happy Clients</div>
          </div>
        </div>
      </div>
    </section>
  );
};
